<template>
  <div v-cloak class="user-message">
    <div class="titles-right">个人信息</div>
    <div class="message">
      <div class="userimg">
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <img src="../img/moren.png" alt="" v-else />
        <el-upload
          class="avatar-uploader"
          id="upl"
          action
          :show-file-list="false"
          :http-request="picUpload"
          :before-upload="beforeAvatarUpload"
          >修改图片</el-upload
        >
      </div>
      <div class="names">
        <span>姓名：</span>
        <el-input @input="names" type="text" v-model="uname"></el-input>
      </div>
      <div class="names">
        <span>昵称：</span>
        <el-input type="text" v-model="nickName"></el-input>
      </div>

      <!-- <div class="names">
        <span>角色：</span>
        <el-input type="text" v-model="Type" disabled></el-input>
      </div> -->

      <div class="names">
        <span>邮箱：</span>
        <el-input type="text" v-model="uemail" disabled></el-input>
      </div>
      <div class="names">
        <span>电话：</span>
        <el-input type="text" v-model="uphone" disabled></el-input>
      </div>

      <div class="names">
        <span>推荐码：</span>
        <el-input type="text" v-model="InviteCode" disabled></el-input>
      </div>


      <div class="ma-t-10 ma-b-20 flex width50">
        <span class="width30 t-right">性别：</span>
        <div class="width70">
          <el-radio-group @change="sex" v-model="usex">
          <el-radio :label="2">男</el-radio>
          <el-radio :label="1">女</el-radio>
          <!-- <el-radio :label="3">保密</el-radio> -->
        </el-radio-group>
        </div>
      </div>
    </div>
    <div class="btns ma-t-40">
      <div @click="tj" class="save">保存</div>
      <el-popover ref="pro" placement="right" width="350" trigger="click">
        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="原密码" prop="pass"
            ><el-input
              @input="oldpassword"
              v-model="oldp"
              type="password"
              autocomplete="off"
            ></el-input
          ></el-form-item>
          <el-form-item label="新密码" prop="pass"
            ><el-input
              @input="newpassword"
              v-model="newp"
              type="password"
              autocomplete="off"
            ></el-input
          ></el-form-item>
          <el-form-item label="确认新密码" prop="checkPass"
            ><el-input
              @input="newpasswords"
              v-model="newsp"
              type="password"
              autocomplete="off"
            ></el-input
          ></el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm" class="green">提交</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <el-button slot="reference">修改密码</el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { getuser, changeuser, userchangepassword, aliupload } from "../api.js";
import axios from "axios";

export default {
  name: "User-message",
  props: {},
  data() {
    return {
      fetch_static: false,
      imageUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      uname: "",
      uphone: "",
      uemail: "",
      usex: 5,
      id: "",
      newp: "",
      newsp: "",
      oldp: "",
      pro: false,
      nickName: "",
      InviteCode:''
    };
  },
  created() {
    this.usermessage();
  },
  // 其他页面进来时更新初始数据
  activated() {
    if (this.$route.meta.title == "false") {
      this.usermessage();
    }
  },
  methods: {
    // 个人信息
    usermessage() {
      let token = localStorage.getItem("AccessToken");
      let datas = {
        token: token,

        source: "pc",
      };
      getuser(datas).then((res) => {
        console.log(res);
        if (res.data.Code == 0) {
          let result = res.data.Data;
          this.imageUrl = result.HeadImage;
          this.uname = result.Name;
          this.uphone = result.Phone;
          this.uemail = result.Email;
          this.usex = result.Gender;
          this.nickName = result.Nickname;
          this.InviteCode = result.InviteCode;
          this.type = result.type;
        }
      });
    },

    names(e) {
      this.uname = e;
      this.fetch_static = false;
    },
    phone(e) {
      this.uphone = e;
      this.fetch_static = false;
    },
    email(e) {
      this.uemail = e;
      this.fetch_static = false;
    },
    sex(e) {
      this.usex = e;
      this.fetch_static = false;
    },
    // 原密码
    oldpassword(e) {
      this.oldp = e;
    },
    // 新密码1
    newpassword(e) {
      this.newp = e;
    },
    // 确认密码
    newpasswords(e) {
      this.newsp = e;
    },

    // 修改密码
    submitForm() {
      let p1 = this.newp;
      let p2 = this.newsp;
      let token = localStorage.getItem("AccessToken");
      // let oldp = localStorage.getItem("password");//如果是验证码登录，则没有旧密码，因此这里去除。
      let oldps = this.oldp;

      // if (oldps != oldp) {
      //   this.$message.error("原密码不正确");
      //   return;
      // }

      if (p1 == "" || p2 == "") {
        this.$message.error("密码不能为空");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(p1)) {
        this.$message.error("密码不能有汉字");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(p2)) {
        this.$message.error("密码不能有汉字");
        return;
      }

      if (p1 != p2) {
        this.$message.error("二次密码不一致");
        return;
      }

      let datas = {
        Language: 1,
        Token: token,
        OldPassword: oldps,
        Password: p1,
        Password2: p2,
        Source: "pc",
      };

      userchangepassword(datas).then((res) => {
        // console.log(res)
        if (res.data.Code == 0) {
          this.$message({
            message: "密码修改成功",
            type: "success",
          });

          localStorage.setItem("password", p1);
          this.oldp = "";
          this.newp = "";
          this.newsp = "";
          this.$refs.pro.doClose();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 保存
    tj() {
      let token = localStorage.getItem("AccessToken");
      // let phone = this.uphone;
      // let email = this.uemail;
      let name = this.uname;
      let sex = this.usex;
      let img = this.imageUrl;

  
   
      // let regs =
      //   /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      // if (email.length < 1) {
      //   this.$message.error("请输入邮箱地址");
      //   return;
      // }
      // if (!regs.test(email)) {
      //   this.$message.error("邮箱格式不正确！");
      //   return;
      // }

      if (name == "") {
        this.$message.error("请填写姓名！");
        return;
      }
      if (this.nickName == "") {
        this.$message.error("请填写昵称！");
        return;
      }
      let datas = {
        Name: name,
        Phone: this.uphone,
        HeadImage: img,
        Email: this.uemail,
        Sex: sex,
        Source: "web",
        Nickname: this.nickName,
        Token: token,
      };

      changeuser(datas)
        .then((res) => {
          this.fetch_static = true;
          if (res.data.Code == 0) {
            localStorage.setItem("username", name);
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.fetch_static = false;
        });
    },

    picUpload(file) {
      let that = this;
      let datas = {
        bucketName: "",
        area: "",
        folder: "User|Image",
      };
      aliupload(datas).then((res) => {
        if (res.data.Code == 0) {
          var formData = new FormData();
          let key = res.data.Data.Dir + res.data.Data.Key + file.file.name;
          formData.append("key", key);
          formData.append("OSSAccessKeyId", res.data.Data.OSSAccessKeyId);
          formData.append("policy", res.data.Data.Policy);
          formData.append("Signature", res.data.Data.Signature);
          formData.append("file", file.file);
          formData.append("success_action_status", 200);
          let url = res.data.Data.Host;
          let data = formData;
          let imgurl = url + "/" + key;

          axios({
            url: url,
            method: "post",
            data: data,
          }).then(function (datas) {
            console.log(datas);
            that.imageUrl = imgurl;
          });
        }
      });
    },

    beforeAvatarUpload(file) {
      this.fetch_static = false;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style lang="scss" spaced>
.green{
background: #fb004d;

}
.user-message {
  width: 960px;
  min-height: 800px;

  background: #ffffff;
  padding-top: 16px;
  padding-bottom: 161px;
  padding-left: 56px;
  box-sizing: border-box;
  margin-bottom: 40px;
  .el-upload {
    width: 100%;
  }
  .el-popover {
    z-index: 8 !important;
  }
  .titles-right {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 24px;
  }
  .titles-right:before {
    content: "|";
    display: inline-block;
    width: 4px;
    height: 19px;
    background: #fb004d;
    color: #fb004d;
    border-radius: 2px;
    margin-right: 8px;
  }
  .message {
    min-height: 369px;
    margin-top: 43px;
    margin-bottom: 66px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    font-weight: 540;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
   .names {
      width: 50%;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 10px;
      padding-top: 10px;
      span {
        width: 30%;
        text-align: right;
      }
      .el-input {
        width: 70%;
      }
      .el-input__inner {
        border: none;
      }
    }
    .userimg {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      .avatar-uploader {
        cursor: pointer;
        width: 126px;
        height: 32px;
        border-radius: 20px;
        border: 1px solid #fb004d;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #fb004d;
        text-align: center;
        line-height: 32px;
        margin-left: 23px;
      }
    }
  }
  .btns {
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .save {
      width: 208px;
      height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 40px;
      color: #ffffff;
      background: #fb004d;
      margin-right: 40px;
      cursor: pointer;
    }
    .change {
      width: 208px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 40px;
      color: #fb004d;
      border: 1px solid #fb004d;
      display: flex;
      align-items: center;
    }
    .el-button {
      width: 208px;
      height: 40px;
      border: 1px solid #fb004d;
      color: #fb004d;
      border-radius: 20px;
    }
  }
}
</style>
